import type { WizardState } from '../types';

interface Props {
  state: WizardState;
  update: <K extends keyof WizardState>(k: K, v: WizardState[K]) => void;
}

const MAX_MOTION_CHARS = 300;

export function Step4MotionBrief({ state, update }: Props) {
  const count = state.motionPrompt.length;
  return (
    <section className="flex flex-col gap-5">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-bold text-fg">Describe the motion</h1>
        <p className="text-sm text-fg-muted">
          What should your character do? Be specific about action + style. The next step lets you pick the engine.
        </p>
      </header>

      <div className="flex flex-col gap-1.5">
        <label htmlFor="ed-motion" className="text-xs font-semibold uppercase text-fg-muted">
          Motion prompt
        </label>
        <textarea
          id="ed-motion"
          value={state.motionPrompt}
          onChange={e => update('motionPrompt', e.target.value.slice(0, MAX_MOTION_CHARS))}
          placeholder="Dancing energetically with arms raised, looping…"
          className="min-h-[140px] rounded-xl bg-bg-secondary p-3 text-sm text-fg placeholder:text-fg-muted/60 focus:outline-none"
        />
        <p className="text-right text-[11px] text-fg-muted">{count} / {MAX_MOTION_CHARS}</p>
      </div>

      <div className="rounded-xl bg-bg-secondary p-3 text-xs leading-relaxed text-fg-muted">
        <p className="font-semibold text-fg">Tips</p>
        <ul className="mt-1 space-y-0.5">
          <li>• Describe the action ("dancing", "casting a spell", "spin attack").</li>
          <li>• Add an adverb ("energetically", "slowly", "with attitude").</li>
          <li>• Hint at the loop ("seamlessly", "looping") for a clean Hub overlay.</li>
        </ul>
      </div>
    </section>
  );
}

export function step4Valid(state: WizardState): boolean {
  return state.motionPrompt.trim().length >= 3;
}
